import React from 'react';
import { IGenderIcon } from './types';

import { GenderEnum } from '../../types';

import GenderMale from '@icons/userflow/GenderMale';
import GenderFemale from '@icons/userflow/GenderFemale';
import GenderUnknown from '@icons/userflow/GenderUnidentified';

const ICONS_MAP = {
  [GenderEnum.MALE]: GenderMale,
  [GenderEnum.FEMALE]: GenderFemale,
  [GenderEnum.UNKNOWN]: GenderUnknown,
};

const GenderIcon: React.FC<IGenderIcon> = props => {
  const { className, type } = props;

  const element = ICONS_MAP[type];

  if (!element) {
    return null;
  }

  return React.createElement(element, { className });
};

export default React.memo(GenderIcon);
